// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular
  .module('frontDoorPage')
  .directive('giFaqTrackOmni', ($window, siteMap) => ({
    restrict: 'C',

    link(scope, element, attrs) {
      $(element)
        .find('a[data-omni]')
        .click(function () {
          return $(document).trigger('track.landing.faqClick', {
            content: $(this).attr('data-omni'),
          });
        });

      return $(element)
        .find('a[data-omni-return-top]')
        .click(() => $(document).trigger('track.landing.returnTopFaqClick'));
    },
  }));
